import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Popup, PhotoSwipeWrapper, Content } from '.';

@inject('SaleStore') @observer
export default class SaleItem extends Component {
  constructor(props) {
    super(props);
    this.openPhotoSwipe = this.openPhotoSwipe.bind(this);
  }

  componentWillMount() {
    const { SaleStore } = this.props;
		const { params } = this.props.match;
		SaleStore.loadSaleContent(params.id);
  }

  openPhotoSwipe(e, file, title) {
    this.refs.photoSwipeWrapper.openPhotoSwipe(e, file, title);
  }

  render() {
    const { SaleStore } = this.props;
    return(
      <PhotoSwipeWrapper ref="photoSwipeWrapper">
        <Popup id="popup-product-item"
          onClose={() => this.props.history.goBack()}
          title={SaleStore.selectedSaleContent.category.name}
          subtitle={SaleStore.selectedSale.name}>

          <section className="content">
            <Content
              content={SaleStore.selectedSaleContent.content}
              onOpenPhotoSwipe={this.openPhotoSwipe} />
          </section>
        </Popup>
      </PhotoSwipeWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SaleItem.js